import React from "react";

import { isMediumScreen } from "../../services";
import MobileHeader from "./MobileHeader";
import WebHeader from "./WebHeader";
import handleFloating from "../../HOCs/handleFloating";
import getWidthContext from "../../HOCs/getWidthContext";
import history from "../../history";

const Header = (props: any) => {
  const {
    showLogoAndSearchBar,
    transparent,
    isHomePage,
    onSubmitAdClick,
    user,
    scrollingLock,
    width
  } = props;

  const handleLogoClick = () => {
    history.replace("/");
  };

  const mobile = isMediumScreen(width);

  if (mobile) {
    return (
      <MobileHeader
        showLogoAndSearchBar={showLogoAndSearchBar}
        isHomePage={isHomePage}
        onSubmitAdClick={onSubmitAdClick}
        onLogoClick={handleLogoClick}
        scrolling={scrollingLock}
        user={user}
      />
    );
  }
  return (
    <WebHeader
      showLogoAndSearchBar={showLogoAndSearchBar}
      transparent={transparent}
      onSubmitAdClick={onSubmitAdClick}
      user={user}
      onLogoClick={handleLogoClick}
      scrolling={scrollingLock}
    />
  );
}

Header.defaultProps = {
  transparent: true,
  user: null
};

export default handleFloating(getWidthContext(React.memo(Header)));



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx